import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/sections/services/performance-marketing/meta-ads/MetaAdsCTA.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/sections/services/performance-marketing/meta-ads/MetaAdsFunnel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/sections/services/performance-marketing/meta-ads/MetaAdsHero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/sections/services/performance-marketing/meta-ads/MetaAdsProcess.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/sections/services/performance-marketing/meta-ads/MetaAdsWhatIs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/sections/services/performance-marketing/meta-ads/MetaAdsWhatWeManage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/sections/services/performance-marketing/meta-ads/MetaAdsWhyCreativeMatters.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
